import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { api } from "../lib/api";
import { useSite } from "../lib/SiteContext";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import GalleryGrid from "../components/GalleryGrid";
import NewsSection from "../components/NewsSection";
import Manifesto from "../components/Manifesto";
import Lightbox from "../components/Lightbox";
import Footer from "../components/Footer";

export default function Gallery() {
  const { settings } = useSite();
  const [artworks, setArtworks] = useState(null);
  const [news, setNews] = useState(null);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    api.get("/artworks").then((r) => setArtworks(r.data)).catch(() => setArtworks([]));
    api.get("/news").then((r) => setNews(r.data)).catch(() => setNews([]));
  }, []);

  const featured = artworks?.find((a) => a.featured) || artworks?.[0];

  return (
    <main data-testid="gallery-page">
      <Hero artwork={featured} />
      <Marquee />
      <GalleryGrid artworks={artworks || []} onSelect={setSelected} />
      <NewsSection posts={news} />
      <Manifesto settings={settings} />
      <Footer settings={settings} />
      <AnimatePresence>
        {selected && (
          <Lightbox
            artwork={selected}
            contact={settings?.contact_email}
            onClose={() => setSelected(null)}
          />
        )}
      </AnimatePresence>
    </main>
  );
}
